import { Steps, Step } from 'components/Docs/Steps';
import SvelteInstallClient from "../../../../contents/docs/integrate/_snippets/install-svelte-client.mdx";
import SvelteInstallServer from "../../../../contents/docs/integrate/_snippets/install-svelte-server.mdx";
import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSymbolSets from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-symbol-sets.tsx";
import * as React from 'react';
export default {
  Steps,
  Step,
  SvelteInstallClient,
  SvelteInstallServer,
  StepVerifyErrorTracking,
  StepUploadSymbolSets,
  React
};